import { PAGE_API_QUERY_KEY_HEAD } from '@Core/clients/pageApiQueryKeys';
import { createApi } from '@Pages/pageRuntime/sdk/api';
import { toApiError } from '@Pages/pageRuntime/sdk/apiErrors';
import type {
  SdkPackageReleaseNotes,
  SdkPackageReleaseNotesOptions
} from '@Pages/pageRuntime/sdk/types';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const NO_PACKAGES: SdkPackageReleaseNotes['packages'] = [];

export function usePackageReleaseNotes({
  packageId,
  limit,
  enabled = true
}: SdkPackageReleaseNotesOptions = {}): SdkPackageReleaseNotes {
  const query = useQuery<
    Diagonal.Packages.Data.PackageReleaseHistoryListData,
    ReturnType<typeof toApiError>
  >({
    queryKey: [
      PAGE_API_QUERY_KEY_HEAD,
      'packages',
      'release-notes',
      packageId ?? null,
      limit ?? null
    ],
    enabled,
    retry: false,
    throwOnError: false,
    queryFn: async ({ signal }) => {
      const params = new URLSearchParams();

      if (packageId) {
        params.set('package_id', packageId);
      }

      if (limit !== undefined) {
        params.set('limit', String(limit));
      }

      const search = params.toString();

      return createApi(axios).get<Diagonal.Packages.Data.PackageReleaseHistoryListData>(
        `/api/packages/release-notes${search ? `?${search}` : ''}`,
        { signal }
      );
    }
  });
  const data = enabled && !query.isError ? query.data : undefined;

  return {
    packages: data?.packages ?? NO_PACKAGES,
    isLoading: enabled && query.isLoading,
    error: enabled ? query.error : null,
    refetch: async () => {
      if (enabled) {
        await query.refetch();
      }
    }
  };
}
